let config = {
    hiddenCls: 'hidden',
    maxItems: 12,
    scrollToHideTooltip: 50,
    tooltipOffset: 30,
    headerHeight: 95
};

export default class Control {
    constructor() {
        this.items = [];
    }

    addItem(e) {
        // check items limit
        if (this.items.length >= config.maxItems) {
            return;
        }

        let el = $(e.currentTarget);
        let item = {
            id: el.data('compare-add'),
            title: el.data('title'),
            price: el.data('price'),
            url: el.data('url'),
            image: el.data('image'),
            sellerType: el.data('seller-type')
        };

        // add to array
        this.items.push(item);
        this.toggleControlState(item.id);
        this.saveToStorage();
        this.showTooltip();
    }

    removeItem(e) {
        let el = $(e.currentTarget);
        let id = el.data('compare-remove');

        // remove from array
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].id === id) {
                this.items.splice(i, 1);
                this.toggleControlState(id);
                this.saveToStorage();
            }
        }
    }

    showTooltip() {
        let tooltipShown = localStorage.compareTooltipShown;
        if ($(window).width() >= 768 || tooltipShown || !$('[data-compare-tooltip]').length) {
            return false;
        }

        let tooltip = $('[data-compare-tooltip]'),
            compareLinkTop = $('[data-compare-count]').offset().top;

        tooltip.css('top', (window.scrollY > compareLinkTop ? (window.scrollY - config.headerHeight) : `${config.tooltipOffset}px`));
        tooltip.removeClass(config.hiddenCls);
        localStorage.compareTooltipShown = true;
    }

    hideTooltip() {
        $('[data-compare-tooltip]').addClass(config.hiddenCls);
    }

    clearItems() {
        this.items = [];
        this.showAddControl();
        this.saveToStorage();
    }

    toggleControlState(id) {
        this.findRemoveControl(id).toggleClass(config.hiddenCls);
        this.findAddControl(id).toggleClass(config.hiddenCls);
    }

    showAddControl(id) {
        this.findRemoveControl(id).addClass(config.hiddenCls);
        this.findAddControl(id).removeClass(config.hiddenCls);
    }

    showRemoveControl(id) {
        this.findRemoveControl(id).removeClass(config.hiddenCls);
        this.findAddControl(id).addClass(config.hiddenCls);
    }

    findRemoveControl(id) {
        return id ? $(`[data-compare-remove="${id}"]`) : $('[data-compare-remove]');
    }

    findAddControl(id) {
        return id ? $(`[data-compare-add="${id}"]`) : $('[data-compare-add]');
    }

    updateControllersState() {
        for (let i = 0; i < this.items.length; i++) {
            this.showRemoveControl(this.items[i].id);
        }
    }

    saveToStorage() {
        try {
            localStorage.compareItems = JSON.stringify(this.items);
            $(document).trigger('compare:storage:change');
        } catch (e) {
        }
    }

    getFromStorage() {
        try {
            this.items = JSON.parse(localStorage.compareItems) || [];
        } catch (e) {
            this.items = [];
        }
    }

    setListeners() {
        $('[data-compare-clear]')
            .off('click.clear', '', $.proxy(this, 'clearItems'))
            .on('click.clear', '', $.proxy(this, 'clearItems'));

        $('[data-compare-add]')
            .off('click.add', '', $.proxy(this, 'addItem'))
            .on('click.add', '', $.proxy(this, 'addItem'));

        $('[data-compare-remove]')
            .off('click.remove', '', $.proxy(this, 'removeItem'))
            .on('click.remove', '', $.proxy(this, 'removeItem'));

        $('[data-compare-tooltip]')
            .off('click.hide', '', $.proxy(this, 'hideTooltip'))
            .on('click.hide', '', $.proxy(this, 'hideTooltip'));

        $(window).on('scroll.compare-tooltip', () => {
            if (Math.abs(this.initScrollY - window.scrollY) > config.scrollToHideTooltip) {
                this.hideTooltip();
            }
        });

        $(document)
            .off('compare:widget:rebuild', '', $.proxy(this, 'init'))
            .on('compare:widget:rebuild', '', $.proxy(this, 'init'));
    }

    init() {
        this.setListeners();
        this.getFromStorage();
        this.updateControllersState();

        this.initScrollY = window.scrollY;
    }
}
